const vpsPaid = state => state.rates.vpsPaid;
const monitoring = state => state.rates.monitoring;

export default {
  vpsPaid,
  monitoring,
};
